/**
 * Site owner — used for /jarvis access and private fields on /khushi.
 * Change this if you ever use a different Firebase login email.
 */
export const OWNER_EMAIL = "ayush@acchaudhary.com";

export function isOwnerEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.trim().toLowerCase() === OWNER_EMAIL.trim().toLowerCase();
}
